import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalBarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_bar"}/>
}
